import { render, staticRenderFns } from "./EventCategoryBadge.vue?vue&type=template&id=db9b000c&"
import script from "./EventCategoryBadge.vue?vue&type=script&lang=ts&"
export * from "./EventCategoryBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports